<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <!-- 战队id -->
        <!-- <el-cascader ref='cascader2'
          v-model="theBusinessType" clearable filterable
          size='small'
          placeholder='请选择分类'
          :show-all-levels='false'
          :options="getBusinessTypeListAll_data ? getBusinessTypeListAll_data.data : []"
          :props="{ expandTrigger: 'hover', checkStrictly: true, emitPath: false, label: 'btName', value: 'btId', children: 'children' }"
          @change="$refs.cascader2.dropDownVisible=false" >
          <template slot-scope="{ data }" >
            <span onclick="this.parentNode.previousElementSibling.click()" >{{ data.btName }}</span>
          </template>
        </el-cascader> -->
        <el-cascader ref='cascader2' v-model="theBusinessType" clearable filterable size='small' placeholder='请选择分类'
          :show-all-levels='false' :options="getBusinessTypeListAll_data ? getBusinessTypeListAll_data.data : []"
          :props="{ expandTrigger: 'hover', checkStrictly: false, emitPath: false, label: 'btName', value: 'btId', children: 'children' }"
          @change="theBusinessTypeChange">
          <template slot-scope="{ data }">
            <span onclick="this.parentNode.previousElementSibling.click()">{{ data.btName }}</span>
          </template>
        </el-cascader>
        <el-select v-model='theBmcId' @change="theBmcIdChange" size="small" placeholder='请选择模块' clearable>
          <el-option v-for="item in getBusinessModelClassList_data.data||[]" :key="item.bmcId" :label="item.bmcName"
            :value="item.bmcId">
          </el-option>
        </el-select>
        <!-- <el-select v-model='theBusinessId' @change="theBusinessAllChange" size="small" clearable>
            <el-option
                v-for="item in getBusinessList_data.data||[]"
                :key="item.businessId"
                :label="item.businessName"
                :value="item.businessId">
            </el-option>
        </el-select> -->
        <el-input v-model="getBusinessModelTopicList_data.bmtName" placeholder="请输入题目名称" clearable size='small'
          style="max-width:380px;" />
        <el-button v-click.getBusinessModelTopicList type="primary" icon='el-icon-search' size='small'
          style='margin-left:10px;'>搜索
        </el-button>
      </el-col>
      <el-col :span="6">
       <!-- <el-button v-if="theBusinessType&&theBmcId" @click="addTopic" size='small' type="primary" style="float:right"
          icon='el-icon-circle-plus'>添加项目模型题目
        </el-button> -->
        <el-button v-if="theBusinessType&&theBmcId" @click="CompileTopic" size='small' type="primary" style=""
          icon='el-icon-circle-plus'>编辑项目模型题目
        </el-button>
      </el-col>
    </el-row>


    <mytable :tableColums='tableColums_getBusinessModelTopicList' api='getBusinessModelTopicList'
      xupdateapi='updateBusinessModelTopic' :height="H-165">
      <icol slot='businessAttrList1' slot-scope='{row}'>
        <el-row>
          <el-col :span="20">
            <div v-for="item in row.businessAttrList" :key="item.attrId">
              <el-row>
                <!-- <el-col :span="2">标签 : {{item.attrKey}}</el-col> -->
                <el-col :span="10">内容 : {{item.attrName}}</el-col>
                <el-col :span="6">推荐业务 : {{item.businessName}}</el-col>
                <el-col :span="4" v-if="item.downBmtName">下级题目 : {{item.downBmtName}}</el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="4">
            <el-button @click="toUpdateBusinessAttrBidForm(row)" size='mini' type="primary">设置业务
        </el-button>
          </el-col>
        </el-row>
      </icol>
    </mytable>

    <el-dialog
      title="设置业务"
      :visible.sync="updateBusinessAttrBidForm"
      width="70%">
      <mytable :tableColums='tableColums_getBusinessAttrList' api='getBusinessAttrList'
        xupdateapi='updateBusinessAttrBid' :height="H-165">
      </mytable>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updateBusinessAttrBidForm = false">关 闭</el-button>
      </span>
    </el-dialog>

    <myform :viewobj='{
        addBusinessAttrBid:    [ "新增", "el-icon-circle-plus" ],
        updateBusinessAttrBid: [ "修改推荐业务", "el-icon-edit-outline"],
        $succeed$: getBusinessAttrList
      }' @close='$form("addBusinessAttrBid","reset")'
      >
      <hide slot='attrId' />
      <template v-slot:businessId="{Myformdata}">
        <el-select v-model='Myformdata.businessId' size="small" placeholder='请选择'>
          <el-option
            v-for="item in getBusinessList_data.data||[]"
            :key="item.businessId"
            :label="item.businessName"
            :value="item.businessId">
          </el-option>
        </el-select>
      </template>
    </myform>

    <!--  <myform :viewobj='{
        addBusinessModelTopic:    [ "新增项目模型题目信息", "el-icon-circle-plus" ],
        updateBusinessModelTopic: [ "修改项目模型题目信息", "el-icon-edit-outline"],
        $succeed$: getBusinessModelTopicList
      }' @close='$form("addBusinessModelTopic","reset")' @confirm='myform'>
      <hide slot='attrId' />
      <hide slot='projectId' />
      <hide slot='businessId' />
      <hide slot='bmtId' />
      <template v-slot:bmtOrder="{Myformdata}">
        <el-input v-model="Myformdata.bmtOrder" type="number" :min="1" :max="100"></el-input>
      </template>
      <template v-slot:businessAttrListString="{Myformdata}">
        <el-button v-model="Myformdata.businessAttrListString" type="primary" size="small" @click="toAddArray">添加
        </el-button>
        <el-table :data="array" style="width: 100%">
          <el-table-column label="标签" align="center" width="260">
            <template slot-scope="scope">
              <el-input v-model="scope.row.attrKey"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="属性名称" align="center" width="260">
            <template slot-scope="scope">
              <el-input v-model="scope.row.attrName"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="100">
            <template slot-scope="scope">
              <el-button type="danger" size="small" @click="toDeleteArray(scope.$index,scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </myform> -->

    <el-dialog :title="compile==false?'新增项目模型题目信息':'编辑项目模型题目信息' " :visible.sync="dialogVisible" width="60%" :before-close="dialogVisibleClose">

      <el-row style="width: 95%;">
        <el-button type="primary" style="margin: 0px 0 10px 85%;" @click="addTopicS">新增题目</el-button>

      </el-row>
      <el-card v-for="(item,index) in formArr" :key="index" style="margin-bottom: 10px;">
        <div v-html="topicTitle" v-if=" item.topicclick== true" style="width: 100%;text-align: center;font-size: 20px;margin: 15px 0;"></div>
        <el-form ref="form" :model="item" label-width="100px" label-position="left">
          <el-row>
            <el-button type="success" style="margin: 0px 0 20px 50px;" @click="updatedTopic(index)">保存改题目</el-button>
            <el-button type="danger" style="margin: 0px 0 20px 50px;" @click="deleteTopic(index)">删除改题目</el-button>
          </el-row>
          <el-form-item label="题目名称">
            <el-input v-model="item.bmtName" style="width: 80%;"></el-input>
          </el-form-item>
          <el-form-item label="题目排序">
            <el-input v-model.number="item.bmtOrder" style="width: 80%;" type="number" :min="1"></el-input>
          </el-form-item>
          <el-form-item label="业务属性选项">
            <el-button type="primary" size="small" @click="toAddArray(item.businessAttrList,item.bmtId)"
              style="margin-left: 20px;">添加选项
            </el-button>
            <el-table :data="item.businessAttrList" style="width: 100%">
              <
              <el-table-column label="属性名称" align="center" width="260">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.attrName"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="下级题目" align="center" width="260">
                <template slot-scope="scope">
                  <span :span="4" v-if="scope.row.downBmtName">{{scope.row.downBmtName}}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="240">
                <template slot-scope="scope">
                  <el-button type="danger" size="small" @click="toDeleteArray(scope.$index,scope.row,item.businessAttrList)">删除
                  </el-button>
                  <el-button type="success" size="small"
                    @click="addSublevelTopic(scope.$index,scope.row,index,item.bmtName)">添加子级题目</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-form>
        <!-- 展示子级 -->
        <!-- <el-card shadow="always">
              总是
        </el-card> -->


      </el-card>



      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addTopicS">新增题目</el-button>
        <el-button  type="primary" @click="dialogVisibleClose">取 消</el-button>
        <!-- <el-button type="primary" @click="dialogVisible = false">确 定</el-button> -->
      </span>
    </el-dialog>



  </div>
</template>

<script>
import myhttp from "../../utils/myhttp.js";
import api from "../../utils/api.js";
import qs from "qs";
  export default {
    data() {
      return {
        updateBusinessAttrBidForm:false,
        compile:false,
        topicclick: false,
        num: 0,
        topicTitle: '',
        attrid: '',
        bmtId: '',
        formArr: [{
          bmtName: '',
          bmtOrder: '',
          topicclick: false,
          businessAttrList: [{
            attrKey: "",
            attrName: "",
            attrId: 1
          }, ],
        }],
        dialogVisible: false,
        form: {
          bmtName: '',
          bmtOrder: '',
        },

        row: {
          qtName: "1"
        },
        attrId: null,

        currentRowId: 1,
        theProjectId: "",
        theBusinessId: "",
        theBusinessType: "",

        tableColums_getBusinessModelTopicList: {
          $selection: false,

          // businessName: '业务名称',

          bmtName: ['题目名称',220],

          businessAttrList1: '选项',

          bmtOrder: ['排序',60,],

          createtime: ['创建时间',120],

          $operation: [
            '操作', 100,
            this.updateBusinessModelTopic && `@text: 编辑#success
           @v-if: theBusinessId != '' && theBusinessId != null
           @click:
           array = $row.businessAttrList
           $form("updateBusinessModelTopic",$row)
          `,
            this.deleteBusinessModelTopic && `@text: 删除#danger
           @click: _confirm('确定要删除该项目模型题目吗?')
                   .trigger('deleteBusinessModelTopic',{bmtId:$row.bmtId})
                   .trigger('getBusinessModelTopicList')
          `,
          ],

        },
        tableColums_getBusinessAttrList: {
          $selection: false,

          // attrKey: '标签',

          attrName: '选项内容',

          businessName: '业务名称',

          createtime: '创建时间',

          $operation: [
            '操作', 200,
            this.updateBusinessAttrBid && `@text: 设置推荐业务#success
            @click:$form("updateBusinessAttrBid",$row)
          `,
          ],

        },

      };
    },

    watch: {

    },

    methods: {
      toUpdateBusinessAttrBidForm(row){
        this.updateBusinessAttrBidForm=true;
        this.getBusinessAttrList({bmtId:row.bmtId})
      },
      toGetBusinessList(){
        this.getBusinessList({pageSize:0})
      },
      // 编辑题目
      CompileTopic(){
        this.compile = true;
        this.dialogVisible = true;
        console.log(this.getBusinessModelTopicList_data,'列表');
        this.formArr = this.getBusinessModelTopicList_data.data
      },

      // 关闭弹框
      dialogVisibleClose() {
        this.dialogVisible = false;
         this.compile = false;
        this.getBusinessModelTopicList()
        // this.formArr = [{
        //   bmtName: '',
        //   bmtOrder: '',
        //   topicclick: false,
        //   businessAttrList: [{
        //     attrKey: "",
        //     attrName: "",
        //     attrId: 1
        //   }],
        // }];

      },
      //新增子级题目
      async addSublevelTopic(index,row,i, name) {
        // console.log( this.formArr[i].array[index].downBmtId,this.bmtId)
        // 题目
        const data = {
          bmtOrder: 1,
          btId: this.theBusinessType,
          bmcId: this.theBmcId,
        }
        var s = qs.stringify(data);
        const responseData = await myhttp.postFileUsers(api.addBusinessModelTopic, s);
        console.log(responseData)
        this.bmtId = responseData.data.data.bmtId;
        //  this.formArr[i].businessAttrList[index].downBmtId = this.bmtId
        //  console.log(this.bmtId + "题目id")
        // console.log(this.formArr[i].businessAttrList[index].attrId + "id")
        this.updateBusinessAttr({
          attrId:this.formArr[i].businessAttrList[index].attrId,
          downBmtId:this.bmtId,
          attrKey:this.formArr[i].businessAttrList[index].attrKey,
          attrName:this.formArr[i].businessAttrList[index].attrName,
        })
        const datas = {
        bmtId: this.bmtId,
        attrKey: "",
          attrName: "",
        }
        var ss = qs.stringify(datas);
        const responseDatas = await myhttp.postFileUsers(api.addBusinessAttr, ss);
        console.log(responseDatas)
        this.attrid = responseDatas.data.data.attrId;
        // this.$nextTick(() => {
        //   // 选项
        //   this.addBusinessAttr({
        //     bmtId: this.bmtId
        //   }).result(res => {
        //     this.attrid = res.data.data.attrId

        //   })
        // })
        this.formArr.push({
          bmtName: "",
          bmtOrder: "",
          btId: this.theBusinessType,
          bmcId: this.theBmcId,
          bmtId: this.bmtId,
          topicclick: true,
          businessAttrList: [{
            attrKey: "",
            attrName: "",
            attrId: this.attrid,
          }],
        });
        this.topicTitle = `<p ><< ${name} >>的子级题目</p>`;
      },
      // 删除该题目
      deleteTopic(Index) {
        console.log(this.formArr,'数组')
        if (Index == 0) {
          this.$confirm('是否删除该题目, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            console.log(this.formArr[Index].bmtId,Index,this.formArr)
            // const bmtid = this.formArr[Index].bmtId
            this.deleteBusinessModelTopic({bmtId:this.formArr[Index].bmtId});
            this.dialogVisible = false;
            this.getBusinessModelTopicList()
            // this.formArr[Index].bmtId = '';
            // this.formArr[Index].bmtName = '';
            // this.formArr[Index].bmtOrder = '';
            // this.formArr[Index].businessAttrList = [{
            //   attrKey: "",
            //   attrName: "",
            //   attrId: 1
            // }, ]
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            });
          });

        } else {
          this.$confirm('是否删除该题目, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.deleteBusinessModelTopic({bmtId:this.formArr[Index].bmtId});
            this.formArr.splice(Index, 1);
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            });
          });
        }
      },

      // 保存该题目
      updatedTopic(Index) {
        console.log(Index)
        this.$confirm('是否保存该题目, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          this.formArr[Index].btId = this.theBusinessType,
            this.formArr[Index].bmcId = this.theBmcId,
            await this.updateBusinessModelTopic(this.formArr[Index])
          for (let i in this.formArr[Index].businessAttrList) {
            console.log(this.formArr[Index].businessAttrList[i])

            this.updateBusinessAttr_api(this.formArr[Index].businessAttrList[i])
          }
          this.$message({
            type: 'success',
            message: '保存成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });

      },
      async updateBusinessAttr_api(data) {
         console.log("111111",data)
         var s = qs.stringify(data);
         const responseData = await myhttp.postFileUsers(api.updateBusinessAttr, s);
           //  this.updateBusinessAttr(data)
      },

      // 新增多道题目
      async addTopicS(num) {
          const data = {
            bmtOrder: 1,
            btId: this.theBusinessType,
            bmcId: this.theBmcId,
          }
          var s = qs.stringify(data);
          const responseData = await myhttp.postFileUsers(api.addBusinessModelTopic, s);
          console.log(responseData)
          this.bmtId = responseData.data.data.bmtId;
         const datas = {
            bmtId: this.bmtId,
            attrKey: "",
            attrName: "",
         }
         var ss = qs.stringify(datas);
         const responseDatas = await myhttp.postFileUsers(api.addBusinessAttr, ss);
         console.log(responseDatas)
         this.attrid = responseDatas.data.data.attrId;
        // this.$nextTick(() => {
        //   this.addBusinessAttr({
        //     bmtId: this.bmtId
        //   }).result(res => {
        //     this.attrid = res.data.data.attrId
        //     console.log(this.attrid)
        //   })
        // })

        this.formArr.push({
          bmtName: "",
          bmtOrder: "",
          btId: this.theBusinessType,
          bmcId: this.theBmcId,
          bmtId: this.bmtId,
          topicclick: false,
          businessAttrList: [{
            attrKey: "",
            attrName: "",
            attrId: this.attrid,
          }],
        });


      },
      handleClose(done) {
        this.$confirm('确认关闭?')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      async addTopic() {

        this.dialogVisible = true
        // this.$form('addBusinessModelTopic');
        // 新增项目题目
        const data = {
          bmtOrder: 1,
          btId: this.theBusinessType,
          bmcId: this.theBmcId,
        }
        var s = qs.stringify(data);
        const responseData = await myhttp.postFileUsers(api.addBusinessModelTopic, s);
        console.log(responseData)
           this.formArr[0].bmtId = responseData.data.data.bmtId
              console.log("新增id", this.formArr[0].bmtId)

        // 新增选项
        this.$nextTick(()=>{
          console.log("新增id", this.formArr[0].bmtId)
          this.addBusinessAttr({
            bmtId: this.formArr[0].bmtId
          }).result(res => {
            this.formArr[0].businessAttrList = [{
              attrKey: "",
              attrName: "",
              bmtId : this.formArr[0].bmtId,
              attrId: res.data.data.attrId
            }]

          })
        })



      },
      theBusinessTypeChange(e) {
        // this.theBusinessId="";
        this.theBusinessType = e;
        this.getData();
      },
      theBmcIdChange(e) {
        this.theBmcId = e;
        this.getData();
      },
      theBusinessAllChange(e) {
        this.theBusinessId = e;
        this.getBusinessModelTopicList({
          businessId: this.theBusinessId
        });
      },
      theProjectAllChange(e) {
        this.theProjectId = e;
        this.getBusinessModelTopicList({
          projectId: this.theProjectId
        });
      },
      changeRedio(event, row) {
        this.currentRowId = event;
      },
      toAddArray(data, id) {
        this.addBusinessAttr({
          bmtId: id
        }).result(res => {
          data.push({
            attrKey: "",
            attrName: "",

            attrId: res.data.data.attrId
          });
        })
      },
      qttIdChange(e) {
        this.theQttId = e;
      },
      toDeleteArray(index, row, data) {

        if (data.length == 1) {
          return;
        } else {
          this.deleteBusinessAttr({
            attrId: data[index].attrId
          })
          data.splice(index, 1);
        }

      },
      myform(submit, Myformdata) {
        this.array.forEach(element => {
          if (element.attrName == null || element.attrName == '') {
            this.$message({
              message: '选项名称不能为空',
              type: 'warning'
            });
          }
        });
        Myformdata.btId = this.theBusinessType;
        Myformdata.bmcId = this.theBmcId;
        Myformdata.businessAttrListString = JSON.stringify(this.array);
        submit();
      },
      getData() {
        this.getBusinessModelTopicList({
          btId: this.theBusinessType,
          bmcId: this.theBmcId
        });
      }
    },

    created() {
      this.getData();
      this.getBusinessTypeListAll();
      // this.getBusinessList({pageSize:0,businessIds:this.theBusinessType});
      this.getBusinessModelClassList({
        pageSize: 0
      });
      this.toGetBusinessList();
    }
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/model/ProjectModelManage.vue